export const ChatRoute = '/chat';
export const ExploreGptRoute = '/explore';
export const PersonalGptRoute = '/personalgpt';
export const PersonalGptSpecificRoute = '/personalgpt/:id';
export const ChatSpecificRoute = '/chat/:id';
export const SettingsRoute = '/settings';
export const AdminSettingsRoute = '/adminsettings';
export const ErrorRoute = '/error';

export const buildRoute = (routePattern: string, routeParams: { [key: string]: string }, separator: string = ':') => {
    let route = routePattern;
    Object.keys(routeParams).forEach((key) => {
        const paramValue = routeParams[key];
        route = route.replace(`${separator}${key}`, paramValue);
    });
    return route;
};
